const getRootDomain = (input: string | URL): string => {
  const url = typeof input === 'string'
    ? new URL(input) : input;

  const domain = url.hostname;
  const elems = domain.split('.');
  if (elems.length <= 2) {
    return domain;
  }
  const iMax = elems.length - 1;

  const elem1 = elems[iMax - 1];
  const elem2 = elems[iMax];

  const isSecondLevelDomain = iMax >= 3 && (elem1 + elem2).length <= 5;
  return `${isSecondLevelDomain ? `${elems[iMax - 2]}.` : ''}${elem1}.${elem2}`;
};

export default getRootDomain;
